module.exports = __webpack_public_path__ + "d964bebbc278ba241a260991d1337f9a.svg";